import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { ExpenseCategoriesPage } from '../../features/finance/categories-page'

export const Route = createFileRoute('/_app/expense-categories')({
  staticData: { crumb: 'expenseCategories' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'expenses.read'),
  component: ExpenseCategoriesPage,
})
